import {ApiBase} from '../utils/apiBase';
let basePath = 'https://act.vip.163.com/midactivity';

export class getUser extends ApiBase {
  method = 'GET'
  url = basePath + '/user'
}

export class getPrizes extends ApiBase {
  method = 'GET'
  url = basePath + '/home/prizes'
}

export class getMyPrizes extends ApiBase {
  method = 'GET'
  url = basePath + '/user/prizes'
}


export class getRecords extends ApiBase {
  method = 'GET'
  url = basePath + "/home/records"
}

export class getBalance extends ApiBase {
  method = 'GET'
  url = basePath + '/user/balance'
}

export class postDraw extends ApiBase {
  method = 'POST'
  url = basePath + '/draw'
}

export class postAddress extends ApiBase {
  method = 'POST'
  url = basePath + '/address'
}

export class getAddress extends ApiBase {
  method = 'GET'
  url = basePath + '/address'
}

export class getProbability extends ApiBase {
  method = 'GET'
  url = basePath + '/home/probability'
}

export class logout extends ApiBase {
  method = 'POST'
  url = basePath + '/logout'
}

export class getFinish  extends ApiBase {
  method = 'GET'
  url = basePath + '/global/finish'
}

// export class submitApi extends ApiBase {
//   // url = "http://10.224.41.146:3000/api/submit";
//   url = "http://127.0.0.1:3001/api/submit";
// }

// export class getDonateInfo extends ApiBase {
//   // url = "http://10.224.41.146:3000/api/donation";
//   url = "http://127.0.0.1:3001/api/donation"
// }